import PropTypes from 'prop-types';

// Components
import Text from '../Global/Text';

const Description = ({ desc, more }) => (
  <Text value={desc} className="form__description" component="p" more={more}/>
);

export default Description;

Description.defaultProps = {
  more: null,
};

Description.propTypes = {
  desc: PropTypes.string.isRequired,
  more: PropTypes.string,
};